module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'camadas-tree': _vm.level == 0
    }
  }, [(_vm.level > 0) ? _c('div', {
    staticClass: "camadas-tree-item",
    class: [{
      'camadas-tree-item-active': (_vm.isGrupo && _vm.open) || (!_vm.isGrupo && _vm.model.habilitado),
      'camadas-tree-grupo': _vm.isGrupo,
      'camadas-tree-camada': !_vm.isGrupo,
      'last-item': _vm.last
    }, _vm.model.cssClass ? _vm.model.cssClass : ''],
    on: {
      "click": function($event) {
        _vm.onClick()
      }
    }
  }, [_vm._l((_vm.indents), function(showTreeLine) {
    return _c('div', {
      staticClass: "camadas-indent"
    }, [(showTreeLine) ? _c('div', {
      staticClass: "tree-line"
    }) : _vm._e()])
  }), (_vm.level > 1) ? _c('div', {
    staticClass: "camadas-indent last-indent"
  }, [_c('div', {
    staticClass: "tree-line"
  }), _c('hr')]) : _vm._e(), (_vm.isGrupo) ? _c('div', {
    staticClass: "camadas-tree-item-nome"
  }, [_c('i', {
    staticClass: "fa",
    class: {
      'fa-folder-open': _vm.open, 'fa-folder': !_vm.open
    }
  }), _vm._v(_vm._s(_vm.model.nome)), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.open && _vm.hasChildren),
      expression: "open && hasChildren"
    }],
    staticClass: "complementar-tree-line"
  })]) : _vm._e(), (!_vm.isGrupo) ? _c('div', {
    staticClass: "dtable-cell camadas-tree-item-nome"
  }, [_c('label', {
    staticClass: "custom-control custom-checkbox"
  }, [_c('input', {
    staticClass: "custom-control-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.model.habilitado
    },
    on: {
      "change": function($event) {
        _vm.onCamadaCheck()
      }
    }
  }), _c('span', {
    staticClass: "custom-control-indicator"
  }), _c('span', {
    staticClass: "custom-control-description"
  }, [_vm._v(_vm._s(_vm.model.nome))])])]) : _vm._e()], 2) : _vm._e(), _c('div', {
    staticClass: "camadas-tree-children",
    class: {
      'closed': !_vm.open
    }
  }, [_vm._l((_vm.model.grupos), function(grupo, index) {
    return (_vm.model.grupos) ? _c('camadas-tree', {
      key: grupo._key,
      ref: 'tree-item-' + grupo._key,
      refInFor: true,
      attrs: {
        "model": grupo,
        "grupo-pai": _vm.model,
        "level": _vm.level + 1,
        "first": index === 0,
        "last": index === _vm.model.grupos.length - 1 && _vm.model.camadas.length === 0,
        "indents": _vm.childIndents,
        "emitter": _vm.eventEmitter
      },
      on: {
        "open": _vm.onOpen
      }
    }) : _vm._e()
  }), _vm._l((_vm.model.camadas), function(camada, index) {
    return (_vm.model.camadas) ? _c('camadas-tree', {
      key: camada.id,
      attrs: {
        "model": camada,
        "grupo-pai": _vm.model,
        "level": _vm.level + 1,
        "first": index === 0,
        "last": index === _vm.model.camadas.length - 1,
        "indents": _vm.childIndents,
        "emitter": _vm.eventEmitter
      },
      on: {
        "open": _vm.onOpen
      }
    }) : _vm._e()
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15075ae8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/camadas/CamadasTree.vue
// module id = 467
// module chunks = 1